/* eslint-disable */

function getLocale() {
  return (
    document.documentElement.getAttribute("lang")?.substring(0, 2).toLowerCase() ||
    (navigator.language || "fi").substring(0, 2).toLowerCase() ||
    "fi"
  );
}

const langMap = { fi: "fi_fi", en: "en_us", sv: "sv_se" };

function getAdobeLang(language) {
  const base = (language || getLocale() || "fi").substring(0, 2).toLowerCase();
  return langMap[base] || "fi_fi";
}

let bonusCalculatorPhaseSent = false;

export function trackBonusCalculatorPhase(language) {
  if (bonusCalculatorPhaseSent) return;
  bonusCalculatorPhaseSent = true;
  const adobeLang = getAdobeLang(language);
  try {
    if (window._satellite) {
      window._satellite.track("application_phase", {
        phase_category: "start",
        name: "bonus calculator",
        group: "tool",
        business_group: "other",
        channel: "ha",
        phase: "calculator started",
        language: adobeLang,
      });
    }
  } catch (e) {
    console.error(e);
  }
};

export const resetButtonSendAnalytics = {
  complete: function (language) {
    const adobeLang = getAdobeLang(language);
    try {
      if (window._satellite) {
        window._satellite.track('application_action', {
          action_name: "empty rows",
          action_group: 'button',
          name: "bonus calculator",
          group: 'tool',
          business_group: "other",
          channel: 'ha',
          phase: "calculator emptied",
          language: adobeLang,
        });
      }
    } catch (e) {
      console.error(e);
    }
  }
};

export function trackBonusCalculatorCompletedPhase({
  language,
  loansSumRange,
  unsecuredLoansSumRange,
  investmentsSumRange,
  savingsSumRange,
  premiumsSumRange,
  estimatedBonusesSumRange
}) {
  const adobeLang = getAdobeLang(language);
  try {
    if (window._satellite) {
      window._satellite.track("application_phase", {
        phase_category: "completed",
        name: "bonus calculator",
        group: "tool",
        business_group: "other",
        channel: "ha",
        phase: "bonuses calculated",
        sum_range: loansSumRange,
        sum_range_2: unsecuredLoansSumRange,
        sum_range_3: investmentsSumRange,
        sum_range_4: savingsSumRange,
        sum_range_5: premiumsSumRange,
        sum_range_6: estimatedBonusesSumRange,
        language: adobeLang
      });
    }
  } catch (e) {
    console.error(e);
  }
};

